module.exports = "div {\n  pointer-events: none!important;\n}\n/deep/svg {\n  background-color: transparent!important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/plotly/plotly.component.css
// module id = ./src/app/shared/plotly/plotly.component.css
// module chunks = main